import api from './api';
import queryString from 'query-string';

const resource = 'TermAcceptance/';

export const isAccepted = async ({ userId, termName } = {}) => {
  const params = new URLSearchParams();
  if (userId) params.append('UserId', userId);
  if (termName) params.append('TermName', termName);
  const query = params.toString();
  return await api.get(resource + `IsAccepted${query ? '?' + query : ''}`);
};

export const create = async (body) => {
  return await api.post(resource + 'Create', body);
};

export const bulkCreate = async (body) => {
  return await api.post(resource + 'BulkCreate', body);
};

export const list = async (query) => {
  return await api.get(
    resource +
      `List?${queryString.stringify(query, {
        skipNull: true,
      })}`,
  );
};

// Caller'ın kendi onayladığı (imzaladığı) agreement'lar — kişiselleştirilmiş
// merchanttermhtml + acceptedat. Admin izni gerekmez, JWT'deki user'a scope'lu.
export const mine = async (termName, companyid) => {
  const params = new URLSearchParams();
  if (termName) params.append('termName', termName);
  if (companyid) params.append('companyid', companyid);
  const q = params.toString();
  return await api.get(resource + 'Mine' + (q ? '?' + q : ''));
};

const termAcceptanceApi = { isAccepted, create, bulkCreate, list, mine };

export default termAcceptanceApi;
